import { render, staticRenderFns } from "./FootprintPageSingleAdd.vue?vue&type=template&id=3f4b46ad&scoped=true&"
import script from "./FootprintPageSingleAdd.vue?vue&type=script&lang=js&"
export * from "./FootprintPageSingleAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4b46ad",
  null
  
)

export default component.exports